import type { SystemConfig } from "../Types/SystemConfig";

export type SystemConfigKey = keyof Pick<
  SystemConfig,
  "is_service" | "is_mobileshop" | "is_restaurant" | "is_whatsapp_enabled" | "is_courier_enabled" | "is_sms_gateway_enable"
>;

export interface FeatureGateRule {
  featureCodes: string[];
  configKeys: SystemConfigKey[];
  logic: "any" | "all";
}

export const FEATURE_GATE_RULES: FeatureGateRule[] = [
  {
    featureCodes: ["repair_jobs"],
    configKeys: ["is_service", "is_mobileshop"],
    logic: "any",
  },
  {
    featureCodes: ["restaurant_tables"],
    configKeys: ["is_restaurant"],
    logic: "any",
  },
  {
    featureCodes: ["whatsapp_integration"],
    configKeys: ["is_whatsapp_enabled"],
    logic: "any",
  },
  {
    featureCodes: ["courier_manage"],
    configKeys: ["is_courier_enabled"],
    logic: "any",
  },
  {
    featureCodes: ["sms_integration"],
    configKeys: ["is_sms_gateway_enable"],
    logic: "any",
  },
];

const toBool = (v: string | boolean | undefined): boolean => {
  if (typeof v === "boolean") return v;
  return v === "1" || v === "true";
};

export const getHiddenFeatureCodes = (config: SystemConfig | undefined): string[] => {
  const hidden: string[] = [];

  for (const rule of FEATURE_GATE_RULES) {
    const hasRequiredConfig = rule.logic === "any"
      ? rule.configKeys.some((key) => toBool(config?.[key]))
      : rule.configKeys.every((key) => toBool(config?.[key]));

    if (!hasRequiredConfig) {
      hidden.push(...rule.featureCodes);
    }
  }

  return hidden;
};

export const isFeatureEnabledByConfig = (
  featureCode: string,
  config: SystemConfig | undefined
): boolean => {
  for (const rule of FEATURE_GATE_RULES) {
    if (rule.featureCodes.includes(featureCode)) {
      const hasRequiredConfig = rule.logic === "any"
        ? rule.configKeys.some((key) => toBool(config?.[key]))
        : rule.configKeys.every((key) => toBool(config?.[key]));
      return hasRequiredConfig;
    }
  }
  return true;
};